import { Injectable } from '@angular/core';
import { NbToastrConfig, NbToastRef, NbToastrService } from '@nebular/theme';

@Injectable({ providedIn: 'root' })
export default class ToastManager {
	private _isDismissible: boolean = false;
	private _defaultDismissableDuration: number = 5 * 60 * 1000;

	constructor(private readonly service: NbToastrService) {}

	success(title: string, message?: string, config?: Partial<NbToastrConfig>): NbToastRef {
		return this.service.success(message, title, config);
	}

	warning(title: string, message?: string, config?: Partial<NbToastrConfig>): NbToastRef {
		return this.service.warning(this._resolveMessage(message), title, this._getConfiguarations(config));
	}

	info(title: string, message?: string, config?: Partial<NbToastrConfig>): NbToastRef {
		return this.service.info(this._resolveMessage(message), title, this._getConfiguarations(config));
	}

	primary(title: string, message?: string, config?: Partial<NbToastrConfig>): NbToastRef {
		return this.service.primary(this._resolveMessage(message), title, this._getConfiguarations(config));
	}

	show(title: string, message?: string, config?: Partial<NbToastrConfig>): NbToastRef {
		return this.service.show(this._resolveMessage(message), title, this._getConfiguarations(config));
	}

	danger(title: string, message?: string, config?: Partial<NbToastrConfig>): NbToastRef {
		return this.service.danger(this._resolveMessage(message), title, this._getConfiguarations(config));
	}

	dismissible(isDismissible: boolean = true): this {
		this._isDismissible = isDismissible;
		return this;
	}

	private _resolveMessage(message?: string): string {
		return this._isDismissible ? `${message ?? ''} (Click to Dismiss)`.trim() : message;
	}

	private _getConfiguarations(config: Partial<NbToastrConfig>): Partial<NbToastrConfig> {
		return {
			destroyByClick: this._isDismissible,
			...(this._isDismissible && { duration: this._defaultDismissableDuration }),
			...config
		};
	}
}
